module.exports = __webpack_public_path__ + "media/images/white-chek-5046da2c91b7df1fa401c17328aa359c.gif";